import React, { useState } from "react";
import ServicesPage from "./ServicesPage";
import MembershipPlansPage from "./MembershipPlansPage";
import { useT } from "../i18n/useT";

// Merged "Services" area — the single-services catalog (ServicesPage) and the
// service bundles (MembershipPlansPage) used to be two separate nav items /
// pages. They now live behind two tabs on one page; each tab panel reuses the
// existing component in `embedded` mode so it drops its own title/heading.
const S = {
  en: { title: "Services", tab_single: "Single services", tab_bundles: "Bundles" },
  am: { title: "አገልግሎቶች", tab_single: "ነጠላ አገልግሎቶች", tab_bundles: "ጥቅሎች" }, // TODO verify am
  om: { title: "Tajaajiloota", tab_single: "Tajaajiloota tokkoo", tab_bundles: "Tuutawwan" }, // TODO verify om
};

export default function ServiceCatalogPage() {
  const { lang } = useT();
  const t = (k) => (S[lang] && S[lang][k]) || S.en[k] || k;
  const [tab, setTab] = useState("single");

  // Tab-pill styling mirrors FinanceReportsPage's tabBtn pattern.
  const tabBtn = (k) => ({
    padding: "7px 14px", borderRadius: 8, cursor: "pointer", fontSize: 13.5, fontWeight: tab === k ? 700 : 500,
    border: tab === k ? "1.5px solid #0F6E56" : "1px solid #e2e6ea", background: tab === k ? "#E7F6EC" : "#fff",
    color: tab === k ? "#0F6E56" : "#5b6472",
  });

  return (
    <div style={{ maxWidth: 960, margin: "0 auto" }}>
      <h1 style={{ marginBottom: 2 }}>{t("title")}</h1>

      <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
        <button style={tabBtn("single")} onClick={() => setTab("single")}>{t("tab_single")}</button>
        <button style={tabBtn("bundles")} onClick={() => setTab("bundles")}>{t("tab_bundles")}</button>
      </div>

      <div style={{ marginTop: 16 }}>
        {tab === "single" ? <ServicesPage embedded /> : <MembershipPlansPage embedded />}
      </div>
    </div>
  );
}
